import TagManager from 'react-gtm-module';
import NetworkError from '../components/GenericError/GenricErrorFunction';
import { offerEligibility } from '../services/offerEligibility';
import { setRecentCoupon } from '../reducer/Incentive';
import store from '../store';

function PharmacyRxFlow(res, isRxFlowType) {
  if (isRxFlowType) {
    if (
      typeof res.response.data !== 'undefined' &&
      typeof res.response.data.govtFlag !== 'undefined' &&
      res.response.data.govtFlag === 'true'
    ) {
      return [
        '/nopharmacyoffer',
        {
          state: { referenceId: res.response.data.referenceId },
        },
      ];
    }

    if (
      typeof res.response.data !== 'undefined' &&
      Array.isArray(JSON.parse(res.response.data.data)) &&
      JSON.parse(res.response.data.data).length > 0
    ) {
      return [
        '/govtfunded',
        {
          state: { offerResponseData: JSON.parse(res.response.data.data) },
        },
      ];
    }
    return [
      '/prescriptionfillscount',
      {
        state: { offerResponseData: 'offer not found' },
      },
    ];
  }
  if (
    typeof res.response.data !== 'undefined' &&
    Array.isArray(JSON.parse(res.response.data.data)) &&
    JSON.parse(res.response.data.data).length > 0
  ) {
    return [
      '/newloyaltycreation',
      {
        state: { offerResponseData: res.response.data },
      },
    ];
  }
  return [
    '/nooffer',
    {
      state: {
        referenceId: res.response.data ? res.response.data.referenceId : '',
      },
    },
  ];
}
function GovtFundedFlow(res) {
  if (
    typeof res.response.data !== 'undefined' &&
    Array.isArray(JSON.parse(res.response.data.data)) &&
    JSON.parse(res.response.data.data).length > 0
  ) {
    return [
      '/newloyaltycreation',
      {
        state: { offerResponseData: res.response.data },
      },
    ];
  }
  return [
    '/nopharmacyoffer',
    {
      state: {
        referenceId: res.response.data ? res.response.data.referenceId : '',
      },
    },
  ];
}

function SubcribedUser(isRxFlowType, offerres, isImzFlowType, updatedObj) {
  if (isRxFlowType) {
    if (
      typeof offerres.response.data !== 'undefined' &&
      typeof offerres.response.data.govtFlag !== 'undefined' &&
      offerres.response.data.govtFlag === 'true'
    ) {
      return [
        '/nopharmacyoffer',
        { state: { referenceId: offerres.response.data.referenceId } },
      ];
    }
    if (
      typeof offerres.response.data !== 'undefined' &&
      Array.isArray(JSON.parse(offerres.response.data.data)) &&
      JSON.parse(offerres.response.data.data).length > 0
    ) {
      return [
        '/govtfunded',
        {
          state: { offerResponseData: updatedObj },
        },
      ];
    }
    return [
      '/prescriptionfillscount',
      {
        state: { referenceId: offerres.response.data.referenceId },
      },
    ];
  }
  if (isImzFlowType) {
    if (
      typeof offerres.response.data !== 'undefined' &&
      Array.isArray(JSON.parse(offerres.response.data.data)) &&
      JSON.parse(offerres.response.data.data).length > 0
    ) {
      return [
        '/newloyaltycreation',
        {
          state: { offerResponseData: offerres.response.data },
        },
      ];
    }
    return [
      '/nooffer',
      {
        state: {
          referenceId: offerres.response.data
            ? offerres.response.data.referenceId
            : '',
        },
      },
    ];
  }
}

function caseCurrentYearHigher(
  birthYear,
  minYear,
  currentMonth,
  birthMonth,
  currentDate,
  birthDate,
) {
  let validationtry = false;

  if (birthYear > minYear) {
    validationtry = true;
  } else if (birthYear === minYear) {
    if (currentMonth < birthMonth) {
      validationtry = true;
    } else if (currentMonth === parseInt(birthMonth, 10)) {
      if (currentDate <= parseInt(birthDate, 10)) {
        validationtry = true;
      }
    }
  }

  return validationtry;
}

function caseCurrentYearEqual(
  currentMonth,
  birthMonth,
  currentDate,
  birthDate,
) {
  let validationtry = false;

  if (currentMonth > birthMonth) {
    validationtry = true;
  } else if (currentMonth === parseInt(birthMonth, 10)) {
    if (currentDate >= parseInt(birthDate, 10)) {
      validationtry = true;
    }
  }

  return validationtry;
}

const calculateDollarStepsForNonSouthern = (
  earnedCouponValue,
  rxCountValue,
  bannerValue,
) => {
  if (
    (earnedCouponValue === undefined && rxCountValue > 0) ||
    (earnedCouponValue === undefined &&
      rxCountValue === 0 &&
      bannerValue === 'Acme')
  ) {
    return 'fiveStepProgress';
  }
  if (
    earnedCouponValue === undefined &&
    rxCountValue === 0 &&
    bannerValue !== 'Acme'
  ) {
    return 'oneStepProgress';
  }
  if (earnedCouponValue === 'old $50' && rxCountValue === 0) {
    return 'sixStepFilledProgress';
  }
  if (earnedCouponValue === 'old $25' || earnedCouponValue === 'new $25') {
    return 'sixStep$50Progress';
  }
  return 'sixStep$50Progress';
};

const handleLookupRxFillCount = ({
  res,
  uniqueOfferIds,
  heroText,
  fullArray,
  setIsCheck,
  setIsrecurring,
  setActiveArray,
  setInActiveArray,
  setShowProgressBar,
}) => {
  let earnedCouponValue;

  const responseData = res.response.data;
  if (responseData?.uniqueOfferId) {
    earnedCouponValue = uniqueOfferIds.find(
      (element) => element.value === parseInt(responseData.uniqueOfferId, 10),
    ).coupon;
  }
  const divisionValue = responseData.storeDivision
    ? responseData.storeDivision
    : 'Others';
  const southernDivision = 'Southern';
  const isSouthernValue =
    divisionValue.toLowerCase() === southernDivision.toLowerCase();

  const rxCountValue = parseInt(responseData.rxFillCount, 10);
  const bannerValue = heroText;
  let activeArraysizetemp1;
  const activeArraysizetemp = parseInt(responseData.rxFillCount, 10);

  if (
    !isSouthernValue &&
    !(
      (earnedCouponValue === 'old $50' && rxCountValue > 0) ||
      earnedCouponValue === 'clac 20%' ||
      earnedCouponValue === 'rec 20%' ||
      earnedCouponValue === 'new $50'
    )
  ) {
    const isNotSouthern = calculateDollarStepsForNonSouthern(
      earnedCouponValue,
      rxCountValue,
      bannerValue,
    );
    if (isNotSouthern === 'fiveStepProgress') {
      activeArraysizetemp1 = activeArraysizetemp;
      fullArray = [0, 1, 2, 3, 4];
      setIsCheck(true);
      setIsrecurring('true');
    } else if (isNotSouthern === 'oneStepProgress') {
      activeArraysizetemp1 = activeArraysizetemp;
      fullArray = [0, 1, 2, 3, 4];
      setIsCheck(true);
      setIsrecurring('false');
    } else if (isNotSouthern === 'sixStepFilledProgress') {
      activeArraysizetemp1 = 6;
      fullArray = [0, 1, 2, 3, 4, 5];
      setIsCheck(false);
      setIsrecurring('filled');
    } else if (isNotSouthern === 'sixStep$50Progress') {
      activeArraysizetemp1 = activeArraysizetemp + 1;
      fullArray = [0, 1, 2, 3, 4, 5];
      setIsCheck(false);
      setIsrecurring('false');
    }
  } else {
    activeArraysizetemp1 = activeArraysizetemp + 1;
    fullArray = [0, 1, 2, 3, 4, 5];
    setIsCheck(false);
    setIsrecurring('true');
  }
  const actArr = fullArray.slice(0, activeArraysizetemp1);
  const inactArr = fullArray.slice(activeArraysizetemp1, fullArray.length);
  setActiveArray(actArr);
  setInActiveArray(inactArr);
  setShowProgressBar(true);

  return fullArray;
};

export const NoCopounText = {
  ACME: 'Fill five new or transferred prescriptions and get 20% off*',
  SOUTHERN:
    'Transfer or fill a new prescription to earn $25 off, plus 20% off when you fill five more*',
  NON_SOUTHERN:
    'Transfer or fill a new prescription to earn $25 off, plus $50 off when you fill five more*',
};

const getTextByDivision = (data) => {
  const southernList = ['TX', 'LA'];
  const acmeList = ['NJ'];
  const nonsouthernList = [
    'Denver',
    'Southwest',
    'Southern California',
    'Shaws',
    'Seattle',
    'Portland',
    'Haggen',
    'Intermountain',
    'Northern California',
  ];
  if (!data?.storeDivision) {
    return NoCopounText.NON_SOUTHERN;
  }
  if (southernList.includes(data?.storeState)) {
    return NoCopounText.SOUTHERN;
  }
  if (acmeList.includes(data?.storeState)) {
    return NoCopounText.ACME;
  }
  if (nonsouthernList.includes(data?.storeDivision)) {
    return NoCopounText.NON_SOUTHERN;
  }
  return '';
};

const handleIncentivePostFormService = ({
  res,
  preincentiveObj,
  isImzFlowType,
  isRxFlowType,
  navigate,
  setIsLoading,
  firstSubmitflag,
  setFirstSubmitError,
  setFirstSubmitflag,
}) => {
  if (NetworkError(res) !== undefined) {
    navigate(NetworkError(res), { state: { redirecting: true } });
    return;
  }

  if (res?.response?.data?.status === 'found') {
    if (res.response.data.hipaaConsent === 'true') {
      const flowType = isImzFlowType ? 'immunization' : 'prescription';
      const customObj = {
        flowType,
        notificationPhoneNumber: '',
        email: '',
        referenceId: res.response.data.referenceId,
        notificationSubscription: false,
        hippaConsent: true,
      };

      const updatedObj = {
        ...customObj,
        ...{ governmentIssuanceFlag: false },
        ...preincentiveObj,
        ...{ firstSubmitflag: true },
      };

      offerEligibility(updatedObj)
        .then((offerres) => {
          handleOfferEligibility({
            offerres,
            updatedObj,
            navigate,
            isRxFlowType,
            isImzFlowType,
          });
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else {
      navigate('/hipaaconsent', {
        state: { refId: res.response.data.referenceId },
      });
    }
  } else if (res?.response?.response?.data?.status === 'multiple') {
    if (res.response.response.data.referenceId) {
      navigate('/userInfo', {
        state: { refId: res.response.response.data.referenceId },
      });
    }
  } else if (res?.response?.data?.status === 'notfound') {
    if (firstSubmitflag === true) {
      setIsLoading(false);
      setFirstSubmitError(true);
      setFirstSubmitflag(false);
    } else {
      setFirstSubmitError(false);
      navigate('/errorpage', { state: { redirecting: true } });
    }
  }
  const tagManagerArgs = {
    dataLayer: {
      click: {
        event: 'v_click',
        clickType: 'continue',
        clickText: 'Incentive Form Submit',
        clickCheckbox: '',
        Recommended: '',
      },
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

function handleOfferEligibility({
  offerres,
  updatedObj,
  navigate,
  isRxFlowType,
  isImzFlowType,
}) {
  if (NetworkError(offerres) !== undefined) {
    navigate(NetworkError(offerres));
    return;
  }
  store.dispatch(setRecentCoupon(offerres.response.data));
  const returnedObject = SubcribedUser(
    isRxFlowType,
    offerres,
    isImzFlowType,
    updatedObj,
  );
  navigate(returnedObject[0], returnedObject[1]);
}

function handleLookupWithMoreInfoService({
  res,
  navigate,
  isImzFlowType,
  isRxFlowType,
  updatedObj,
}) {
  if (NetworkError(res) !== undefined) {
    navigate(NetworkError(res), {
      state: { redirecting: true },
    });
    return;
  }
  if (res?.response?.data?.status !== 'found') {
    navigate('/errorPage', {
      state: { redirecting: true },
    });
    return;
  }

  if (res.response.data?.hipaaConsent === 'false') {
    navigate('/hipaaconsent', {
      state: { refId: res.response.data.referenceId },
    });
    return;
  }

  offerEligibility(updatedObj).then((offerres) => {
    handleOfferEligibility({
      offerres,
      updatedObj,
      navigate,
      isRxFlowType,
      isImzFlowType,
    });
  });
}

export {
  SubcribedUser,
  PharmacyRxFlow,
  GovtFundedFlow,
  caseCurrentYearHigher,
  caseCurrentYearEqual,
  handleLookupRxFillCount,
  handleIncentivePostFormService,
  handleLookupWithMoreInfoService,
  handleOfferEligibility,
  getTextByDivision,
};
